import { TNotificationActionLevel } from "./actionLevels";
import { TNotificationActionType } from "./actionTypes";
import { showNotification } from "./notificationsSlice";
import { INotification } from "./sliceTypes";

export type { INotification };

export function showNotificationActionCreator(
  _type: TNotificationActionType,
  level: TNotificationActionLevel,
  message: string,
  detailedMessage?: string,
) {
  return showNotification({ level, message, detailedMessage });
}
